import React from 'react';
import { useUserRole } from '../hooks/useUserRole';

// Componente di esempio che mostra contenuti diversi in base al ruolo dell'utente
export const RoleBasedAccess = ({ children, requiredRole }) => {
  const { isAdmin, isResTecnico, isBasicUser } = useUserRole();

  // Funzione per verificare se l'utente ha i permessi necessari
  const hasAccess = () => {
    switch (requiredRole) {
      case 'admin':
        return isAdmin;
      case 'resTecnico':
        // Gli admin hanno accesso anche alle funzionalità dei resTecnico
        return isAdmin || isResTecnico;
      case 'basic':
        // Tutti gli utenti autenticati hanno accesso alle funzionalità di base
        return isAdmin || isResTecnico || isBasicUser;
      default:
        return false;
    }
  };

  // Renderizza i children solo se l'utente ha i permessi necessari
  return hasAccess() ? children : null;
};

// Componenti specializzati per ciascun ruolo
export const AdminOnly = ({ children }) => (
  <RoleBasedAccess requiredRole="admin">{children}</RoleBasedAccess>
);

export const ResTecnicoAccess = ({ children }) => (
  <RoleBasedAccess requiredRole="resTecnico">{children}</RoleBasedAccess>
);

export const BasicUserAccess = ({ children }) => (
  <RoleBasedAccess requiredRole="basic">{children}</RoleBasedAccess>
);